import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Col,
  Row,
  MultiColumnList,
  IconButton,
} from '@folio/stripes/components';
import AssignUserPlugin from '../assign-user-plugin';
import { USER_FIELDS } from '../../../../../../../../constants';
import { getLastFirstUserName } from '../../../../../../../../utils';

import css from './assign-user-list.css';

const AssignUserList = ({ deleteUser, addUser, members }) => {
  const intl = useIntl();

  const visibleColumns = [
    USER_FIELDS.STATUS,
    USER_FIELDS.NAME,
    USER_FIELDS.EMAIL,
    USER_FIELDS.ACTIONS,
  ];
  const columnMapping = {
    [USER_FIELDS.STATUS]: <FormattedMessage id="ui-task-list.user.field.status" />,
    [USER_FIELDS.NAME]: <FormattedMessage id="ui-task-list.user.field.name" />,
    [USER_FIELDS.EMAIL]: <FormattedMessage id="ui-task-list.user.field.email" />,
    [USER_FIELDS.ACTIONS]: '',
  };
  const listEmptyMessage = (
    <span className={css.emptyListError}>
      <FormattedMessage id="ui-task-list.user.list.noUsers" />
    </span>
  );
  const formatter = useMemo(() => {
    return {
      status: (user) => {
        return user.active
          ? <FormattedMessage id="ui-task-list.user.field.status.active" />
          : <FormattedMessage id="ui-task-list.user.field.status.inactive" />;
      },
      name: (user) => user.personal && getLastFirstUserName(user),
      email: (user) => user?.personal.email,
      actions: (user) => (
        <IconButton
          data-test-memberships-actions-remove
          aria-label={intl.formatMessage({ id: 'ui-task-list.user.actions.remove' })}
          icon="trash"
          size="medium"
          onClick={() => deleteUser(user)}
        />
      ),
    };
  }, [deleteUser]);

  return (
    <>
      <Row end="xs">
        <Col xs={12}>
          <AssignUserPlugin onUsersSelect={addUser} />
        </Col>
      </Row>
      <Row
        data-test-assigned-users
        start="xs"
      >
        <Col xs={12}>
          <MultiColumnList
            columnMapping={columnMapping}
            contentData={members}
            formatter={formatter}
            id="assigned-members-list"
            isEmptyMessage={listEmptyMessage}
            visibleColumns={visibleColumns}
          />
        </Col>
      </Row>
    </>
  );
};

AssignUserList.propTypes = {
  addUser: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  members: PropTypes.arrayOf(PropTypes.object),
};

AssignUserList.defaultProps = {
  members: [],
};

export default AssignUserList;
